export function setErrors(errors){
  return {
    type : "SET_ERRORS",
    errors
  }
}